<template>
  <div class="row no-gutters recharge-container">
    <section class="col-lg-8 recharge-details-container">
      <ul class="nav nav-tabs active-buttons" id="activationOptionsTabs">
        <li class="nav-item ">
          <a class="nav-link active mobile" href="#mobile_recharge" data-toggle="tab">
            <button type="button" class="btn btn-black btn-block">Mobile</button>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link lte" href="#fixed_lte_recharge" data-toggle="tab">
            <button type="button" class="btn btn-black btn-block">Fixed LTE</button>
          </a>
        </li>
      </ul>
      <div class="tab-content">
        <div class="tab-pane active" id="mobile_recharge">
          <div class="section-heading">
            <h3>Recharge</h3>
          </div>
          <div class="recharge-details">
            <p>Choose any combination of the bundles below that you would like to buy.</p>
            <product-selector :recharge.sync="recharge" v-on:recharge:paynow="payNow"></product-selector>
          </div>
        </div>
        <div class="tab-pane" id="fixed_lte_recharge">
          <div class="section-heading">
            <h3>Fixed LTE</h3>
          </div>
          <div class="recharge-details">
            <p>Not many people know the LTE mobile number for their SIMs. So please login to the manage area and select "MANAGE" for the product you would like to top up.</p>
            <vue-login v-if="!isAuthenticated"></vue-login>
            <a v-if="isAuthenticated" type="button" class="btn btn-primary" href="/backend.html" >
              Manage Area
              <i class="fa fa-chevron-right" aria-hidden="true"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
    <section class="col-lg-4 recharge-summary-container">
      <recharge-info :products="selectedProducts"></recharge-info>
    </section>
  </div>
</template>


<script>
import EventBus from "@/components/shared/event-bus";

import OrderService from "@/services/order.service.js";
import RechargeModel from "@/models/recharge.model";
import RechargeInfo from "./recharge-info.vue";
import ProductSeclector from "./product-selector.vue";
import VueLogin from "@/components/elements/vue-login";
import { mapGetters } from "vuex";

export default {
  name: "recharge-details",
  components: {
    "product-selector": ProductSeclector,
    "recharge-info": RechargeInfo,
    "vue-login": VueLogin
  },
  data: function() {
    return {
      recharge: new RechargeModel()
    };
  },
  computed: {
    ...mapGetters(["isAuthenticated"]),
    selectedProducts() {
      var self = this;
      var products = [];
      if (!self.isEmpty(self.recharge.data)) products.push(self.recharge.data);
      if (!self.isEmpty(self.recharge.mins)) products.push(self.recharge.mins);
      if (!self.isEmpty(self.recharge.sms)) products.push(self.recharge.sms);
      if (!self.isEmpty(self.recharge.whatsApp))
        products.push(self.recharge.whatsApp);
      return products;
    }
  },
  methods: {
    payNow() {
      var self = this;
      EventBus.$emit("global_loading", {
        is_loading: true,
        loading_message: "Processing Request..."
      });
      self.$log.debug("Payment request", self.recharge);
      //Payment Request. Redirect to payment on success.
      OrderService.recharge(
        self.recharge.formatedMsisdn(),
        self.recharge.getSelectedProducts()
      )
        .then(function(response) {
          self.$log.debug("Payment request response", response);
          var r = response.data;
          if (r.success) {
            self.$log.debug("Payment Request", r);
            self.$router.push({
              name: "payment",
              params: {
                CHECKSUM: r.data.CHECKSUM,
                PAY_REQUEST_ID: r.data.PAY_REQUEST_ID
              }
            });
          } else {
            EventBus.$emit("global_loading", { is_loading: false });
          }
        })
        .catch(function(error) {
          EventBus.$emit("global_loading", { is_loading: false });
          self.recharge.has_error = true;
          self.recharge.message =
            "We could not process your payment. Please contact support for further assistance.";
          if (
            !self.isEmpty(error.response) &&
            !self.isEmpty(error.response.data)
          ) {
            self.recharge.message = error.response.data.message;
          }
          self.$log.error("Error requesting payment", error);
        });
    },

    isEmpty(data) {
      return (
        data == null ||
        typeof data == "undefined" ||
        Object.keys(data).length === 0
      );
    }
  }
};
</script>